import { parseZone } from "moment";
import { DATE_FORMAT } from "../constants/date";

const parseDate = (
  value: string,
  format: string = DATE_FORMAT
): string | null => {
  if (!value) {
    return null;
  }

  const parsedValue = parseZone(value.toString());

  if (parsedValue.isValid()) {
    return parsedValue.format(format);
  }

  return null;
};

export default parseDate;
